<div class="grid" *ngIf="deliverableDetail$ | async as deliverableDetail">
  <app-deliverable-cr-update-section [deliverableDetail]="deliverableDetail"></app-deliverable-cr-update-section>
  <app-deliverable-soft-update-section-view
    [deliverableDetail]="deliverableDetail"
  ></app-deliverable-soft-update-section-view>
</div>
